var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"amap-wrapper"},[_c('el-amap',{staticClass:"amap-box",attrs:{"vid":"task-amap","amap-manager":_vm.amapManager,"zoom":12,"center":_vm.center,"expand-zoom-range":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }